import React, { Component } from "react";
import { withTranslation } from "react-i18next";
import { Button, Container, Form, Grid, Image } from "semantic-ui-react";
import HeaderComponent from "../header/HeaderComponent";
import LoadingComponent from "../helpers/LoadingComponent";
import MessagesComponent from "../helpers/MessagesComponent";
import SupplyChainShareSimulationModal from "../modals/SupplyChainShareModal";
import LeftTitleComponent from "../titles/leftTitle/LeftTitleComponent";
import MainTitleComponent from "../titles/mainTitle/MainTitleComponent";
import * as CONSTANT from "../../constants/UniversalConstants";
import CreateSupplyChainSimulationForm from "./createSupplyChainSimulationForm";
import { compose } from "redux";
import { connect } from "react-redux";
import moment from "moment";
import {
  supplychainCreateSimulation,
  supplychainCreateAutomaticSimulation,
  resetCreateSimulationDefaults,
  resetSupplyChainBuySimulationStoreDefaults,
  restoreSupplyChainPurchaseInformationFromStorage,
  supplyChainConfirmPayment,
} from "../../store/SupplyChainBuySimulation/actions";
import "./purchasedSupplyChainStyles.css";
import { createSupplyChainLink, supplyChainValidateDates } from "../utilities/SupplyChainSimulationUtilities";
import { withRouter } from "react-router-dom";
import { setStorage } from "../../services/StorageService";
import * as LOCALSTORAGE from "../../constants/LocalStorage";
import * as SUPPLYCHAIN_CONSTANTS from "../../constants/SupplyChainConstants";
import { SUPPLY_CHAIN_SIMULATION_DETAILS } from "../../constants/Routes";
import { supplyChainGetProfessorScenarios } from "../../store/SupplyChainSimulationDetails/actions";
import gearIcon from "../../assets/gear-icon.svg";
import AdvancedOptions from "../supplyChainAdvancedOptions/AdvancedOptions";
import { switchTo12HourFormat, unifyDateTime } from "../utilities/DateTimeUtilities";
import PaymentVerificationModal from "../modals/PaymentVerificationModal";
import { confirmPaymentStatuses } from "../../utilities/storeStatusDictionary";

class PurchasedSupplyChain extends Component {
  constructor(props) {
    super(props);

    const startDate = moment().add(1, "hour");
    const endDate = startDate.clone().add(1, "day");
    let paymentIntentId;
    const params = new URLSearchParams(window.location.search);
    if (params.has("payment_intent")) {
      paymentIntentId = params.get("payment_intent");
    }

    this.state = {
      formValidated: false,
      openAdvancedOptions: false,
      advancedOptions: {
        scenarioId: "",
      },
      dateValidationError: {},
      form: {
        simulationName: {
          value: "",
          valid: true,
          rules: {
            minLength: 1,
          },
        },
        gameMode: {
          value: SUPPLYCHAIN_CONSTANTS.OneStationUnknownPeers,
          valid: true,
          rules: {},
        },
        professorAdvance: {
          value: true,
          valid: true,
          rules: {},
        },
        startTime: {
          value: {
            hour: switchTo12HourFormat(Number(moment(startDate).format("HH"))),
            hourFormat: moment(startDate).format("a"),
            date: startDate,
          },
          valid: true,
          rules: {},
        },
        endTime: {
          value: {
            hour: switchTo12HourFormat(Number(moment(endDate).format("HH"))),
            hourFormat: moment(endDate).format("a"),
            date: endDate,
          },
          valid: true,
          rules: {},
        },
        timeBetweenAdvances: {
          value: 1,
          valid: true,
          rules: {},
        },
      },
      paymentIntentId: paymentIntentId,
    };
  }

  async componentDidMount() {
    this.props.restoreSupplyChainPurchaseInformationFromStorage();
    this.props.resetCreateSimulationDefaults();
    this.verifyPayment();
    this.props.getProfessorScenarios();
  }

  verifyPayment = async () => {
    if (typeof this.state.paymentIntentId === "string") {
      await this.props.confirmPayment(this.state.paymentIntentId);
    }
  };

  submitCreateSimulationRequest = (event) => {
    event.preventDefault();
    if (!this.state.formValidated) {
      const updatedForm = this.updateFormValidation(this.state.form);
      this.setState({ form: updatedForm, formValidated: true });
      return;
    }

    const form = this.state.form;
    const formValid = Object.keys(form).every((key) => {
      const formEntry = form[key];
      return formEntry.valid;
    });

    if (!formValid) {
      return;
    }

    if (this.state.form.professorAdvance.value) {
      const request = {
        simulationName: this.state.form.simulationName.value,
        gameMode: this.state.form.gameMode.value,
        paymentSummaryId: this.props.paymentSummaryId,
        scenarioId: this.state.advancedOptions.scenarioId,
      };

      this.props.supplychainCreateSimulation(request);
      return;
    }

    const endTime = form.endTime;
    const unifiedStartTime = unifyDateTime(form.startTime.value);
    const unifiedEndTime = unifyDateTime(endTime.value);
    const pace = this.state.form.timeBetweenAdvances.value;

    const dateValidation = supplyChainValidateDates(unifiedStartTime, unifiedEndTime, pace);

    if (dateValidation.invalidEndTime || dateValidation.invalidStartTime) {
      this.setState({
        form: {
          ...form,
          startTime: {
            ...form.startTime,
            valid: !dateValidation.invalidStartTime,
          },
          endTime: {
            ...form.endTime,
            valid: !dateValidation.invalidEndTime,
          },
        },
        formValidated: true,
        dateValidationError: dateValidation.dateValidationError,
      });
      return;
    }

    const request = {
      simulationName: this.state.form.simulationName.value,
      gameMode: this.state.form.gameMode.value,
      paymentSummaryId: this.props.paymentSummaryId,
      startTime: unifiedStartTime,
      endTime: unifiedEndTime,
      pace: this.state.form.timeBetweenAdvances.value,
      scenarioId: this.state.advancedOptions.scenarioId,
    };

    this.props.supplychainCreateAutomaticSimulation(request);
  };

  onFormChanged = (id, data) => {
    const updatedForm = { ...this.state.form };
    const updatedFormElement = { ...updatedForm[id] };
    updatedFormElement.value = data;
    updatedFormElement.valid = this.validateFormValue(updatedFormElement.value, updatedFormElement.rules);
    updatedForm[id] = updatedFormElement;
    this.setState({ form: updatedForm, formValidated: true });
  };

  updateFormValidation = (form) => {
    const updatedForm = {};
    Object.keys(form).forEach((key) => {
      const updatedElement = { ...form[key] };
      updatedElement.valid = this.validateFormValue(updatedElement.value, updatedElement.rules);
      updatedForm[key] = updatedElement;
    });
    return updatedForm;
  };

  validateFormValue = (value, rules) => {
    let isValid = true;
    if (rules.minLength) {
      isValid = isValid && value.length >= rules.minLength;
    }

    if (rules.minHoursBeforeDate) {
      const timeNow = moment();
      const unifiedDate = unifyDateTime(value);
      isValid = isValid && unifiedDate.diff(timeNow) >= rules.minHoursBeforeDate;
    }
    return isValid;
  };

  onModalDismiss = () => {
    const simulationId = this.props.createSimulation.simulationId;
    this.props.resetSupplyChainBuySimulationStoreDefaults();
    setStorage(LOCALSTORAGE.requestedSimulation, simulationId);
    this.props.history.push(`${SUPPLY_CHAIN_SIMULATION_DETAILS}?simulationId=${simulationId}`);
  };

  setDate = (date, dateToModify) => {
    let updatedForm = { ...this.state.form };

    const segmentedStartTime = updatedForm.startTime.value;
    const segmentedEndTime = updatedForm.endTime.value;

    if (dateToModify === "startDate" && date >= moment(segmentedEndTime.date).format("YYYY-MM-DD")) {
      segmentedStartTime.date = date;
      segmentedEndTime.date = moment(date).add(1, "day");
    } else {
      if (dateToModify === "startDate") {
        segmentedStartTime.date = date;
      } else {
        segmentedEndTime.date = date;
      }
    }

    updatedForm = this.updateFormValidation(updatedForm);
    this.setState({ form: updatedForm, formValidated: true, dateValidationError: {} });
  };

  setHour = (statePropertyToModify, value) => {
    let updatedForm = { ...this.state.form };
    const segmentedStartTime = updatedForm[statePropertyToModify].value;

    if (isNaN(value)) {
      segmentedStartTime.hourFormat = value;
    } else {
      segmentedStartTime.hour = value;
    }

    updatedForm = this.updateFormValidation(updatedForm);
    this.setState({ form: updatedForm, formValidated: true, dateValidationError: {} });
  };

  handleAdvancedOptionsComponent = () => {
    this.setState({
      openAdvancedOptions: !this.state.openAdvancedOptions,
    });
  };

  onAdvancedOptionsChanged = (id, value) => {
    const { advancedOptions } = this.state;
    this.setState({
      advancedOptions: {
        ...advancedOptions,
        [id]: value,
      },
    });
  };

  handleAdvancedOptionsComponent = () => {
    this.setState({
      openAdvancedOptions: !this.state.openAdvancedOptions,
    });
  };

  onAdvancedOptionsChanged = (id, value) => {
    const { advancedOptions } = this.state;
    this.setState({
      advancedOptions: {
        ...advancedOptions,
        [id]: value,
      },
    });
  };

  render() {
    const { t: translate, confirmPaymentStatus } = this.props;
    const { simulationCreated, createdSimulationMessage, simulationId, errorMessage, loading, shortLink } =
      this.props.createSimulation;

    if (
      confirmPaymentStatus.status === confirmPaymentStatuses.loading ||
      confirmPaymentStatus.status === confirmPaymentStatuses.fail
    ) {
      return <PaymentVerificationModal state={confirmPaymentStatus} retryAction={this.validatePayment} />;
    }

    let navigationButton = null;
    navigationButton = (
      <div className="supplychainBottomArea">
        <Button basic type="submit" form="createSimulationForm">
          {translate("continue")}
        </Button>
      </div>
    );

    if (loading) {
      navigationButton = <LoadingComponent message={translate("creatingSimulation")} />;
    }

    let messagesComponent = null;
    let translatedErrorMessage = "";
    const { dateValidationError } = this.state;
    if (typeof dateValidationError.message === "string") {
      translatedErrorMessage = translate(dateValidationError.message, { hours: dateValidationError.hours });
    }
    if (errorMessage !== "") {
      translatedErrorMessage = translate(errorMessage);
    }
    if (translatedErrorMessage !== "") {
      messagesComponent = <MessagesComponent message={translatedErrorMessage} />;
    }

    const shareLink = typeof shortLink === "string" ? shortLink : createSupplyChainLink(simulationId);
    const shareSimulationModal = (
      <SupplyChainShareSimulationModal
        translate={translate}
        open={simulationCreated}
        shareLink={shareLink}
        titleModal={translate(createdSimulationMessage)}
        titleSecondaryButton={translate("ModifyModal:accept")}
        handleSecondaryButton={() => this.onModalDismiss()}
        messageType={true}
      />
    );

    const { professorScenariosStatus } = this.props;
    const { advancedOptions, openAdvancedOptions } = this.state;
    const advancedOptionsComponent = (
      <>
        <AdvancedOptions
          loading={professorScenariosStatus.loading}
          errorMessage={professorScenariosStatus.errorMessage}
          scenarios={professorScenariosStatus.scenarios}
          advancedOptions={advancedOptions}
          advancedOptionsChanged={this.onAdvancedOptionsChanged}
        />
        <Grid>
          <Grid.Column width={16}>{navigationButton}</Grid.Column>
        </Grid>
      </>
    );

    const willDisplayAdvancedOptionsButton =
      professorScenariosStatus.scenarios !== null &&
      Array.isArray(professorScenariosStatus.scenarios) &&
      professorScenariosStatus.scenarios.length > 0;

    return (
      <Container>
        {shareSimulationModal}
        <HeaderComponent translate={translate} />
        <Grid className="customGrid">
          <Grid.Column only="mobile" mobile={16}>
            <MainTitleComponent title={CONSTANT.SUPPLY_CHAIN_NAME.toUpperCase()} />
          </Grid.Column>
          <Grid.Column only="computer tablet" width={16}>
            <LeftTitleComponent title={CONSTANT.SUPPLY_CHAIN_NAME.toUpperCase()} />
          </Grid.Column>
          <Grid.Column className="formColumn" mobile={16} computer={8} tablet={10}>
            <div>
              <Form id="createSimulationForm" onSubmit={this.submitCreateSimulationRequest}>
                <CreateSupplyChainSimulationForm
                  formData={this.state.form}
                  formChanged={this.onFormChanged.bind(this)}
                  segmentedStartTime={this.state.form.startTime.value}
                  segmentedEndTime={this.state.form.endTime.value}
                  setDate={this.setDate}
                  setHour={this.setHour}
                  language={this.props.language}
                />
              </Form>
              {willDisplayAdvancedOptionsButton ? (
                <Button onClick={this.handleAdvancedOptionsComponent} id="whiteAndBlueButton">
                  <Image className="ui top aligned tiny image" src={gearIcon} id="imageButton" />
                  {translate("SupplyChainPurchased:AdvancedOptions")}
                </Button>
              ) : null}
            </div>
          </Grid.Column>
          <Grid.Column className="logoColumn" only="tablet computer" computer={8} tablet={6} />
        </Grid>
        <Grid>
          <Grid.Row>
            {messagesComponent}
            <Grid.Column width={16}>{navigationButton}</Grid.Column>
          </Grid.Row>
        </Grid>
        {openAdvancedOptions ? advancedOptionsComponent : null}
      </Container>
    );
  }
}

const mapStateToProps = (state) => ({
  confirmPaymentStatus: state.supplychainBuySimulation.confirmPayment,
  professorScenariosStatus: state.supplyChainSimulationDetails.professorScenarios,
  createSimulation: state.supplychainBuySimulation.createSimulation,
  paymentSummaryId: state.supplychainBuySimulation.payment.paymentSummaryId,
  language: state.user.userProfile.language,
});

const mapDispatchToProps = (dispatch) => ({
  confirmPayment: (intentId) => dispatch(supplyChainConfirmPayment(intentId)),
  getProfessorScenarios: () => dispatch(supplyChainGetProfessorScenarios()),
  supplychainCreateSimulation: (request) => dispatch(supplychainCreateSimulation(request)),
  supplychainCreateAutomaticSimulation: (request) => dispatch(supplychainCreateAutomaticSimulation(request)),
  restoreSupplyChainPurchaseInformationFromStorage: () => dispatch(restoreSupplyChainPurchaseInformationFromStorage()),
  resetCreateSimulationDefaults: () => dispatch(resetCreateSimulationDefaults()),
  resetSupplyChainBuySimulationStoreDefaults: () => dispatch(resetSupplyChainBuySimulationStoreDefaults()),
});

const HOC = compose(
  connect(mapStateToProps, mapDispatchToProps),
  withTranslation("SupplyChainBuySimulation", "SupplyChainPurchased", "Common"),
  withRouter
);

export default HOC(PurchasedSupplyChain);
